import { module } from 'angular';
import templateBuilderSmartFieldDisplay from './builder/display.html';
import templateBuilderSmartFieldData from './builder/data.html';
import templateBuilderSmartFieldValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/smartfield/display.html', templateBuilderSmartFieldDisplay);
	$templateCache.put('kform/components/smartfield/data.html', templateBuilderSmartFieldData);
	$templateCache.put('kform/components/smartfield/validate.html', templateBuilderSmartFieldValidate);
});
